import React, { useState } from "react";
import {
  Box, Paper, Typography, Grid, InputLabel,
  FormControl, Select, MenuItem, Button, Alert
} from "@mui/material";
import { useLocation } from "react-router-dom";

const UploadDocuments = () => {
  const { state } = useLocation();
  const leadId = state?.leadId;

  const [employmentType, setEmploymentType] = useState("");
  const [documents, setDocuments] = useState({});
  const [additionalCount, setAdditionalCount] = useState(1);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setDocuments((prev) => ({ ...prev, [name]: files[0] }));
  };

  const handleSubmit = async () => {
    setStatus({ type: "", message: "" });

    if (!leadId) {
      setStatus({ type: "error", message: "Missing lead reference" });
      return;
    }

    if (!employmentType) {
      setStatus({ type: "error", message: "Please select employment type" });
      return;
    }

    const formData = new FormData();
    formData.append("lead_id", leadId);
    formData.append("employment_type", employmentType);

    const staticFields = ["aadhar_front", "aadhar_back", "pancard", "bank_statement"];
    staticFields.forEach((field) => {
      if (documents[field]) formData.append(field, documents[field]);
    });

    if (employmentType === "Salaried") {
      ["payslip_1", "payslip_2", "payslip_3"].forEach((field) => {
        if (documents[field]) formData.append(field, documents[field]);
      });
    }

    if (employmentType === "Self-employed") {
      ["itr_1", "itr_2"].forEach((field) => {
        if (documents[field]) formData.append(field, documents[field]);
      });
    }

    for (let i = 1; i <= additionalCount; i++) {
      const field = `additional_${i}`;
      if (documents[field]) formData.append(field, documents[field]);
    }

    setIsUploading(true);
    try {
      const res = await fetch("https://core-bankers-backend.vercel.app/upload-documents", {
        method: "POST",
        body: formData
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Upload failed");

      setStatus({ type: "success", message: "Documents uploaded successfully" });
    } catch (err) {
      console.error("Upload error:", err);
      setStatus({ type: "error", message: err.message });
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 4 }, backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
      <Paper sx={{ p: 3, borderRadius: 3, maxWidth: 600, mx: "auto" }}>
        <Typography variant="h6" gutterBottom textAlign="center">
          Upload Documents
        </Typography>

        {status.message && (
          <Alert severity={status.type} sx={{ mb: 2 }}>
            {status.message}
          </Alert>
        )}

        <Grid container spacing={3}>
          {[
            { label: "Aadhar Front", name: "aadhar_front" },
            { label: "Aadhar Back", name: "aadhar_back" },
            { label: "Pancard", name: "pancard" },
            { label: "Bank Statement", name: "bank_statement" }
          ].map(({ label, name }) => (
            <Grid item xs={12} key={name}>
              <InputLabel>{label}</InputLabel>
              <input type="file" name={name} onChange={handleFileChange} style={{ width: "100%" }} />
            </Grid>
          ))}

          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Employment Type</InputLabel>
              <Select
                value={employmentType}
                onChange={(e) => setEmploymentType(e.target.value)}
              >
                <MenuItem value="Salaried">Salaried</MenuItem>
                <MenuItem value="Self-employed">Self-employed</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {employmentType === "Salaried" && (
            <>
              <Grid item xs={12}><InputLabel>Payslip 1</InputLabel><input type="file" name="payslip_1" onChange={handleFileChange} /></Grid>
              <Grid item xs={12}><InputLabel>Payslip 2</InputLabel><input type="file" name="payslip_2" onChange={handleFileChange} /></Grid>
              <Grid item xs={12}><InputLabel>Payslip 3</InputLabel><input type="file" name="payslip_3" onChange={handleFileChange} /></Grid>
            </>
          )}

          {employmentType === "Self-employed" && (
            <>
              <Grid item xs={12}><InputLabel>ITR 1</InputLabel><input type="file" name="itr_1" onChange={handleFileChange} /></Grid>
              <Grid item xs={12}><InputLabel>ITR 2</InputLabel><input type="file" name="itr_2" onChange={handleFileChange} /></Grid>
            </>
          )}

          <Grid item xs={12}>
            <Typography variant="subtitle2">Additional Documents</Typography>
            {Array.from({ length: additionalCount }).map((_, i) => (
              <Box key={i} mb={1}>
                <InputLabel>Document {i + 1}</InputLabel>
                <input
                  type="file"
                  name={`additional_${i + 1}`}
                  onChange={handleFileChange}
                  style={{ width: "100%" }}
                />
              </Box>
            ))}
            <Button variant="outlined" onClick={() => setAdditionalCount((prev) => prev + 1)} fullWidth sx={{ mt: 1 }}>
              + Add More
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleSubmit}
              disabled={isUploading}
              sx={{
                py: 1.4,
                backgroundColor: "#007BFF",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: "6px",
                textTransform: "none",
                fontSize: "1rem",
                "&:hover": {
                  backgroundColor: "#0056b3"
                }
              }}
            >
              {isUploading ? "Uploading..." : "Submit Documents"}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default UploadDocuments;